var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.5,
    height: 41.501,
    viewBox: "0 0 41.5 41.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.025,
    y1: 0.887,
    x2: 2.026,
    y2: -0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1493ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1493ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.965,
    y1: 2.073,
    x2: 0.935,
    y2: -0.064,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.093,
    y1: 1.024,
    x2: 1.888,
    y2: -0.972,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.127,
    y1: 1.939,
    x2: 1.065,
    y2: 0.087,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.263,
    y1: 1.244,
    x2: 1.291,
    y2: -0.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.299,
    y1: 1.366,
    x2: 1.399,
    y2: -0.289,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.369,
    y1: 1.26,
    x2: 1.33,
    y2: -0.395,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3.518,
    y1: 4.42,
    x2: 0.772,
    y2: 0.234,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.304,
    y1: 0.693,
    x2: 4.605,
    y2: -3.488,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9261",
    "data-name": "Group 9261",
    transform: "translate(-63.696 -337.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9259",
    "data-name": "Group 9259",
    transform: "translate(63.696 337.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9257",
    "data-name": "Group 9257",
    transform: "translate(0.066 0.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    d: "M77.663,354.583,66.055,366.19a20.877,20.877,0,0,1-2.3-6.557l9.48-9.481a3.109,3.109,0,0,1,4.419.012,3.172,3.172,0,0,1,.92,2.2A3.13,3.13,0,0,1,77.663,354.583Z",
    transform: "translate(-63.752 -335.334)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M92.3,339.8,81.654,350.443a3.133,3.133,0,1,1-4.431-4.431l8.517-8.516A20.875,20.875,0,0,1,92.3,339.8Z",
    transform: "translate(-61.441 -337.496)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9258",
    "data-name": "Group 9258",
    transform: "translate(10.577 10.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M88.666,365.255l-9.48,9.481a20.521,20.521,0,0,1-6.558-2.3l11.608-11.607a3.122,3.122,0,0,1,5.326,2.2A3.073,3.073,0,0,1,88.666,365.255Z",
    transform: "translate(-72.628 -343.879)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M100.844,352.929l-8.517,8.517a3.132,3.132,0,0,1-4.43-4.43l10.643-10.644A20.525,20.525,0,0,1,100.844,352.929Z",
    transform: "translate(-69.986 -346.372)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M91.6,352.054,78.311,365.345a3.131,3.131,0,0,1-4.43,0l-.012-.011a3.118,3.118,0,0,1,.012-4.419l13.291-13.291a3.128,3.128,0,0,1,4.419-.012l.011.012A3.141,3.141,0,0,1,91.6,352.054Z",
    transform: "translate(-61.991 -335.733)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M95.622,369.366A20.9,20.9,0,0,1,84,375.27a3.106,3.106,0,0,1,.542-3.689l13.291-13.291a3.119,3.119,0,0,1,3.689-.542A20.9,20.9,0,0,1,95.622,369.366Z",
    transform: "translate(-60.026 -333.768)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M80.663,341.117,67.373,354.408a3.139,3.139,0,0,1-3.677.553,21.014,21.014,0,0,1,17.522-17.522A3.157,3.157,0,0,1,80.663,341.117Z",
    transform: "translate(-63.696 -337.439)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    d: "M96.6,345.125l-1.728,1.728a3.141,3.141,0,0,1-4.43,0l-.012-.011a3.108,3.108,0,0,1,.012-4.419l1.728-1.728a20.967,20.967,0,0,1,4.43,4.43Z",
    transform: "translate(-58.942 -336.839)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    d: "M73.108,368.615l-1.728,1.728a20.972,20.972,0,0,1-4.43-4.43l1.728-1.729a3.12,3.12,0,0,1,4.419-.011l.011.011A3.152,3.152,0,0,1,73.108,368.615Z",
    transform: "translate(-63.097 -332.684)",
    fill: "url(#linear-gradient-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9c2e6dc9f383f32773127fa135f564d.svg";
export { ForwardRef as ReactComponent };